<wm-inspection-queue
  [id]="id"
  (recordCountSet)="setRecordCount($event)"
  *ngIf="staticFilters"
  [client]="client"
  [staticFilters]="staticFilters"
  [columns]="columns"
  (updateStatus)="updateStatusEvent($event)"
  (dataLoaded)="emitDataLoaded()"
  (filtersChanged)="filtersChange()"
></wm-inspection-queue>
